<template>
  <router-link :to="to"
               class="block pl-5 pr-2 py-1 font-open-sans text-xl tracking-wide  transition duration-150 ease-in-out font-semibold uppercase"
  >
    {{title}}
  </router-link>
</template>

<script>
  export default {
  name: "NavMobileLink",
  props: {
    to: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
